module.exports = __webpack_public_path__ + "static/media/couchcast_logo.d63cdcfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/couchcast_logo.png
// module id = 78
// module chunks = 0